import { Group } from "@mantine/core";
import { Avatar } from "../components/Avatar";
import type { ICellRendererParams } from "ag-grid-community";

type User = {
  name: string;
  avatar: string | null;
  id: number;
};

type UserOrWithUser = User | { user: User };

export const UserCellRenderer = ({ data }: ICellRendererParams<UserOrWithUser>) => {
  if (!data) return null;

  const user: User = "user" in data
    ? data.user
    : data;

  return (
    <Group>
      <Avatar user={user} size="md" />
      {user.name}
    </Group>
  );
};
